var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVertt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 114 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#9ea0a0;}.cls-3{mask:url(#mask);}.cls-4{mask:url(#mask-2-2);}"), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 36,
    height: 27,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    className: "cls-1",
    points: "0 0 36 0 36 27 0 27 0 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2-2",
    x: 83,
    y: 0,
    width: 31,
    height: 27,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mask-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    className: "cls-1",
    points: "83 0 114 0 114 27 83 27 83 0"
  })))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage-new-section"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_Microtica-2021_-HomePage-v1",
    "data-name": "[Microtica-2021]-HomePage-v1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-46-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "cls-2",
    d: "M68,14.42V27h5.41V14.42c0-2.79,3.48-5.15,7.59-5.15V4C73.83,4,68,8.66,68,14.42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    className: "cls-2",
    d: "M30.52,0a77.29,77.29,0,0,1-3.87,11.46C23.79,18,20.63,21.67,18,21.67S12.14,18,9.3,11.46A78,78,0,0,1,5.42,0H0A91.79,91.79,0,0,0,4.43,13.55C8.33,22.48,12.89,27,18,27s9.64-4.52,13.56-13.45A92.26,92.26,0,0,0,36,0Z",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "cls-2",
    d: "M50.5,9.28c4,0,7.47,1.8,8.71,4.25H41.83c1.26-2.45,4.72-4.25,8.67-4.25m10-2.17A16.77,16.77,0,0,0,50.5,4C42.51,4,36,9.17,36,15.54a10.41,10.41,0,0,0,4.53,8.35A16.77,16.77,0,0,0,50.5,27h9.23V21.72H50.5c-3.66,0-6.89-1.53-8.35-3.66H64.8a22.19,22.19,0,0,0,.2-2.6,10.41,10.41,0,0,0-4.53-8.35",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-8",
    className: "cls-2",
    d: "M114,9.1V3.77h-7.57V0H101V3.77H88.4V0H83V16.47C83,22.27,88.82,27,96,27V21.67c-4.1,0-7.57-2.38-7.57-5.2V9.1H101v7.37c0,5.8,5.82,10.53,13,10.53V21.67c-4.1,0-7.57-2.38-7.57-5.2V9.1Z",
    transform: "translate(0 0)"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertt);
export default __webpack_public_path__ + "static/media/vertt.ec4cfaf8c86d625cb555a2b338ff1372.svg";
export { ForwardRef as ReactComponent };